import createIcon from '../../createIcon';

/**
 * @component @name RssFeed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4zOTk3MyAxOS43Nzk3QzcuNjAzNzEgMTkuNzc5NyA4LjU3OTczIDE4LjgwMzcgOC41Nzk3MyAxNy41OTk3QzguNTc5NzMgMTYuMzk1NyA3LjYwMzcxIDE1LjQxOTcgNi4zOTk3MyAxNS40MTk3QzUuMTk1NzUgMTUuNDE5NyA0LjIxOTczIDE2LjM5NTcgNC4yMTk3MyAxNy41OTk3QzQuMjE5NzMgMTguODAzNyA1LjE5NTc1IDE5Ljc3OTcgNi4zOTk3MyAxOS43Nzk3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQuMjE5NzMgNC4yMTk3M1Y3LjA0OTczQzExLjI0OTcgNy4wNDk3MyAxNi45NDk3IDEyLjc0OTcgMTYuOTQ5NyAxOS43Nzk3SDE5Ljc3OTdDMTkuNzc5NyAxMS4xODk3IDEyLjgwOTcgNC4yMTk3MyA0LjIxOTczIDQuMjE5NzNaTTQuMjE5NzMgOS44Nzk3M1YxMi43MDk3QzguMTE5NzMgMTIuNzA5NyAxMS4yODk3IDE1Ljg3OTcgMTEuMjg5NyAxOS43Nzk3SDE0LjExOTdDMTQuMTE5NyAxNC4zMDk3IDkuNjg5NzMgOS44Nzk3MyA0LjIxOTczIDkuODc5NzNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RssFeed = createIcon('RssFeed', [
  [
    'path',
    {
      d: 'M6.39973 19.7797C7.60371 19.7797 8.57973 18.8037 8.57973 17.5997C8.57973 16.3957 7.60371 15.4197 6.39973 15.4197C5.19575 15.4197 4.21973 16.3957 4.21973 17.5997C4.21973 18.8037 5.19575 19.7797 6.39973 19.7797Z',
      key: '142780',
    },
  ],
  [
    'path',
    {
      d: 'M4.21973 4.21973V7.04973C11.2497 7.04973 16.9497 12.7497 16.9497 19.7797H19.7797C19.7797 11.1897 12.8097 4.21973 4.21973 4.21973ZM4.21973 9.87973V12.7097C8.11973 12.7097 11.2897 15.8797 11.2897 19.7797H14.1197C14.1197 14.3097 9.68973 9.87973 4.21973 9.87973Z',
      key: '1w12v1',
    },
  ],
]);

export default RssFeed;
